import React from "react";
import FeatureCard from "../FeatureCard";

export default () => (
  <FeatureCard to="/support/api-definition" image="/static/img/Documentation.png" imageAlt="Picture of documents" description="What's an API?">
    Find out how Skyward defines an API
  </FeatureCard>
);
